var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import EdModal from "../../../../shared-library/components/edModal";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/DropdownDatePicker.scss";
// import "@frameworks/salesjourney/stylesheets/components/Header/DeskPeriod.scss";
import EdButton from "../../../../web/components/generic/edbutton/edButton";
import moment from "moment";
var dropdownOption = [
    { label: "Select", value: "" },
    { label: "All", value: "All" },
    { label: "For the month", value: "ForMonth" },
    { label: "Custom", value: "custom" },
];
var DropdownDatePicker = function (props) {
    var _a = __read(useState(false), 2), showModal = _a[0], setShowModal = _a[1];
    var _b = __read(useState(undefined), 2), fromDate = _b[0], setFromDate = _b[1];
    var _c = __read(useState(undefined), 2), toDate = _c[0], setToDate = _c[1];
    var _d = __read(useState(dropdownOption[0]), 2), selectedVal = _d[0], setSelectedVal = _d[1];
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.reset) {
            setSelectedVal(dropdownOption[0]);
            setFromDate(undefined);
            setToDate(undefined);
        }
    }, [props === null || props === void 0 ? void 0 : props.reset]);
    return (React.createElement("div", { className: "dropdown-datepicker-container w-100 d-flex flex-column gap-2" },
        React.createElement("span", { className: " DMSanN_16_400" }, props.SelectLabel),
        React.createElement(Select, { defaultValue: dropdownOption[0], value: selectedVal, name: "externalParticipants", options: dropdownOption, className: "basic-multi-select DMSanN_14_400 txt_blackOne1", classNamePrefix: "select", onChange: function (e) {
                if (e.value === "custom") {
                    setShowModal(true);
                }
                else {
                    setFromDate(undefined);
                    setToDate(undefined);
                    setSelectedVal(e);
                    props === null || props === void 0 ? void 0 : props.onChange(e);
                }
            }, closeMenuOnSelect: true }),
        React.createElement(EdModal, { show: showModal, setShow: function (val) {
                setShowModal(val);
                setShowModal(false);
                setFromDate(undefined);
                setToDate(undefined);
            }, showFooter: false, modalTitle: "", closeOnOutsideClick: false, title: "Custom Time Range", children: React.createElement("div", { className: "p-4" },
                React.createElement(DatePicker, { yearDropdownItemNumber: 80, dateFormat: "d-MMM-yy", onChange: function (e) {
                        var _a = __read(e, 2), start = _a[0], end = _a[1];
                        setFromDate(start);
                        setToDate(end);
                    }, startDate: fromDate, endDate: toDate, selectsRange: true, inline: true, formatWeekDay: function (nameOfDay) { return nameOfDay.slice(0, 3); }, showYearDropdown: true, showMonthDropdown: true, scrollableMonthYearDropdown: true, scrollableYearDropdown: true }),
                React.createElement("div", { className: "button-block" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Apply", type: "button", onClick: function () {
                            if (fromDate && toDate) {
                                setSelectedVal({
                                    label: "".concat(moment(fromDate).format("DD/MM/YYYY") +
                                        " - " +
                                        moment(toDate).format("DD/MM/YYYY")),
                                    value: "".concat(moment(fromDate).format("DD/MM/YYYY") +
                                        "-" +
                                        moment(toDate).format("DD/MM/YYYY")),
                                });
                                props === null || props === void 0 ? void 0 : props.onChange({
                                    label: "".concat(moment(fromDate).format("DD/MM/YYYY") +
                                        " - " +
                                        moment(toDate).format("DD/MM/YYYY")),
                                    value: "".concat(moment(fromDate).format("DD/MM/YYYY") +
                                        " - " +
                                        moment(toDate).format("DD/MM/YYYY")),
                                });
                                setShowModal(false);
                            }
                        }, disabled: fromDate && toDate ? false : true }),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", value: "Cancel", type: "button", onClick: function () {
                            setShowModal(false);
                            setFromDate(undefined);
                            setToDate(undefined);
                        } }))) })));
};
export default DropdownDatePicker;
